import { render, staticRenderFns } from "./bank-verification-form.vue?vue&type=template&id=5de81eb4&"
import script from "./bank-verification-form.vue?vue&type=script&lang=js&"
export * from "./bank-verification-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports